import { handleUrl, myHeadersWithTokenContentType } from '../global';
import {
  DetailProps,
  GetAllErrorReportsProps,
  GetErrorReportProps,
  NewReport,
  UpdateReport,
} from './types';

export const getAllErrorReports = (
  page: number,
  size: number,
  finished?: boolean,
  source?: number,
  search?: string
): Promise<GetAllErrorReportsProps> => {
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithTokenContentType(),
  };
  const params: Record<string, string> = {
    page: String(page),
    size: String(size),
  };
  if (finished !== undefined) params.finished = finished.toString();
  if (source) params.report_source = source.toString();
  if (search) params.search_term = search;

  const queryString = new URLSearchParams(params).toString();

  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/error-reports?${queryString}`, requestOptions)
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const addReport = (data: NewReport): Promise<DetailProps> => {
  const requestOptions = {
    method: 'POST',
    headers: myHeadersWithTokenContentType(),
    body: JSON.stringify(data),
  };
  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/error-reports`, requestOptions)
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const getErrorReport = (id: number): Promise<GetErrorReportProps> => {
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithTokenContentType(),
  };
  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/error-reports/${id}`, requestOptions)
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const updateErrorReport = (
  id: number,
  data: UpdateReport
): Promise<DetailProps> => {
  const requestOptions = {
    method: 'PUT',
    headers: myHeadersWithTokenContentType(),
    body: JSON.stringify(data),
  };
  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/error-reports/${id}`, requestOptions)
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const activateElementErrorReport = (
  id: number
): Promise<DetailProps> => {
  const requestOptions = {
    method: 'POST',
    headers: myHeadersWithTokenContentType(),
  };
  const baseUrl = handleUrl();
  return fetch(
    `${baseUrl}/api/V1/error-reports/${id}/actions/activate-element`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};

export const finishElementErrorReport = (id: number): Promise<DetailProps> => {
  const requestOptions = {
    method: 'POST',
    headers: myHeadersWithTokenContentType(),
  };
  const baseUrl = handleUrl();
  return fetch(`${baseUrl}/api/V1/error-reports/${id}/finish`, requestOptions)
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};
